var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitAndLoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53783 10.9928C6.53783 11.2729 6.76489 11.5 7.04499 11.5C7.32508 11.5 7.55215 11.2729 7.55215 10.9928V10.8881C8.3865 10.6841 9 10.007 9 9.20746C9 8.00816 8.11656 7.64103 7.20041 7.38811L7.11008 7.36167C6.52254 7.1901 6.13701 7.07751 6.13701 6.58042C6.13701 6.15618 6.55419 5.8951 7.06135 5.8951C7.55215 5.8951 7.96933 6.21329 7.96933 6.64569H9C9 5.86247 8.37832 5.20163 7.55215 5.01399V5.00716C7.55215 4.72706 7.32508 4.5 7.04499 4.5C6.76489 4.5 6.53783 4.72706 6.53783 5.00716V5.01399C5.71984 5.20979 5.11452 5.85431 5.11452 6.63753C5.11452 7.80947 6.10287 8.07906 6.81157 8.27237L6.88957 8.29371C7.51943 8.48135 7.96933 8.669 7.96933 9.20746C7.96933 9.68065 7.53579 10.0152 6.99591 10.0152C6.45603 10.0152 6.01431 9.68065 6.01431 9.21562H5C5 10.0478 5.6544 10.7413 6.53783 10.9207V10.9928Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7C16.5 6.44772 16.9477 6 17.5 6H18.5C19.0523 6 19.5 6.44772 19.5 7V18C19.5 18.5523 19.0523 19 18.5 19H17.5C16.9477 19 16.5 18.5523 16.5 18V7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9C12.9477 9 12.5 9.44772 12.5 10V18C12.5 18.5523 12.9477 19 13.5 19H14.5C15.0523 19 15.5 18.5523 15.5 18V10C15.5 9.44771 15.0523 9 14.5 9H13.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C8.94772 12 8.5 12.4477 8.5 13V18C8.5 18.5523 8.94771 19 9.5 19H10.5C11.0523 19 11.5 18.5523 11.5 18V13C11.5 12.4477 11.0523 12 10.5 12H9.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16C4.5 15.4477 4.94772 15 5.5 15H6.5C7.05228 15 7.5 15.4477 7.5 16V18C7.5 18.5523 7.05228 19 6.5 19H5.5C4.94772 19 4.5 18.5523 4.5 18V16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitAndLoss);
export default __webpack_public_path__ + "static/media/profitAndLoss.dcba9ef0c754c4d746d583e548841f38.svg";
export { ForwardRef as ReactComponent };